import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import wx from 'weixin-js-sdk'
import './assets/style/reset.css'
import './assets/style/index.scss'
import './assets/style/index.css'
import Vant from 'vant';
import 'vant/lib/index.css';
import VueWechatTitle from 'vue-wechat-title'
import BaiduMap from 'vue-baidu-map';// 百度地图
Vue.use(BaiduMap, {
  ak:'yRWUo5Q8pqlTlbhkU5Bz6xSV2znzY0Vu'
});
Vue.use(VueWechatTitle)
Vue.config.productionTip = false
Vue.prototype.$loca = window.localStorage;
Vue.prototype.$wx = wx;
const whiteList = ['/login', '/adActive','viewPdfsyz', '/exhibition','/salesroom','/appointment','/viewPdfs','/viewHandwriting','/contractStatus'];// 不重定向白名单
router.beforeEach((to, from, next) => {
  next();
  if (Vue.prototype.$loca.getItem('phone')) {
    next()
  } else {
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next('/login'); // 否则全部重定向到登录页

    }
  }
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
